angular.module('concept-map')
    .controller('ConceptMapModalController', [
        '$filter',
        '$interpolate',
        '$modalInstance',
        '$scope',
        '$window',
        '$timeout',
        'iaplApi',
        'dblIaplService',
        'dblLessonService',
        'mapContext',
    function (
        $filter,
        $interpolate,
        $modalInstance,
        $scope,
        $window,
        $timeout,
        iaplApi,
        dblIaplService,
        dblLessonService,
        mapContext
    ) {

    function resetScopeVariables() {
        $scope.selectedLessonGroup = null;
        $scope.selectedLessonGroupName = null;
        $scope.selectedLessonGroupShortDesc = null;
        $scope.selectedLessonGroupLongDesc = null;
        $scope.selectedLessonGroupPdLink = null;
        $scope.selectedLessonGroupStudentCount = 0;
        $scope.selectedLessonGroupStudentNames = null;
        $scope.selectedLessonGroupHasDesignation = null;
    }

    $scope.ready = false;
    $scope.viewMode = mapContext.viewMode;  //student vs classroom

    // Close info pane
    $scope.closeMe = function() {
        document.getElementById("info-pane").style.height = "0";
        resetScopeVariables();
    };

    // currently selected lesson group for the bottom pane
    resetScopeVariables();

    // scope wise caches
    $scope.lessonGroups = {};

    /**
     * A lesson group has been clicked by user
     *
     **/
    $scope.lessonGroupClicked = function(lessonGroupName) {
        resetScopeVariables();
        var selectedLessonGroup = $scope.lessonGroups[lessonGroupName];

        $scope.selectedLessonGroupName = lessonGroupName;
        $scope.selectedLessonGroup = selectedLessonGroup;
        $scope.selectedLessonGroupShortDesc = selectedLessonGroup.sd;
        $scope.selectedLessonGroupLongDesc = selectedLessonGroup.ld;
        $scope.selectedLessonGroupPdLink = selectedLessonGroup.pdLink;
        $scope.selectedLessonGroupHasDesignation = hasDesignation();

        if (selectedLessonGroup &&
            selectedLessonGroup.activityData &&
            selectedLessonGroup.activityData.studentIds) {
            $scope.selectedLessonGroupStudentCount = _.size(selectedLessonGroup.activityData.studentIds);

            if ($scope.selectedLessonGroupStudentCount > 0) {
                var names = [];
                _.forEach(_.keys($scope.selectedLessonGroup.activityData.studentIds), function(studentId) {
                    var student = _.find($scope.students, {student_id: parseInt(studentId)});
                    if (student) {
                        names.push(student.first_name + ' ' + student.last_name);
                    }
                });
                $scope.selectedLessonGroupStudentNames = names.join(', ');
            }
        }
    };

    var hasDesignation = function() {
        var result = false;
        _.forEach($scope.selectedLessonGroup, function(val, key) {
            if (val === 'Y') {
                result = true;
            }
        });
        return result;
    };

    $scope.getLessonImage = function(lessonGroupName) {
       return dblLessonService.getImageForDblStandard(lessonGroupName);
    };

    $scope.getDemoLessonUrl = function(selectedLessonGroup) {

      if (!selectedLessonGroup) {
         return null;
      }

      var  demo_lesson_name = selectedLessonGroup.demo;
      if (selectedLessonGroup.activityData && selectedLessonGroup.activityData.demo_lesson_name) {
         demo_lesson_name = selectedLessonGroup.activityData.demo_lesson_name;
      }

      if (demo_lesson_name === undefined) {
        return null;
      }

      return dblLessonService.getDemoLink(demo_lesson_name);
    };

    function updateLists(lessonGroups, studentLessonGroups) {
        $scope.students = studentLessonGroups;

        _.forEach(lessonGroups, function(event) {
            var lessonGroup = $scope.lessonGroups[event.name];
            lessonGroup.activityData = event;

            //TODO: use a better way to signal the change
            $scope.lessonGroups[event.name] = _.clone(lessonGroup);
        });
    }

    // get all lesson groups
    var promise = iaplApi.getLessonGroups();
    promise.$promise.then(function(lessonGroups) {
        var _lessonGroups = lessonGroups;

        // retrieve pd links and attach them to the lesson groups
        var lessonGroupNames = _.keys(_lessonGroups);
        dblIaplService.retrievePdLocations(lessonGroupNames).then(function(pdLocations) {
            _.forEach(_lessonGroups, function(lessonGroup) {
                lessonGroup.pdLink = pdLocations[lessonGroup.name];  // attach pdlink
            });
            dblIaplService.getLists({includeAssignFocusActivities: true, context: 'concept-map', viewMode: $scope.viewMode})
                .then(function(data) {
                      updateLists(data.lessonGroups, data.studentLessonGroups);
                }).finally(function() {
                // ...
            });

            $scope.lessonGroups = _lessonGroups;
            $scope.ready = true;
        });
    });
}]);
